import { useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { useAuth } from "@/core/hooks/useAuth";
import { useAjudaPapel } from "@/core/hooks/useAjudaPapel";
import { montarLicoes } from "@/core/ajuda/licoes";
import { BTN_PRIMARIO, BTN_TEXTO, PAGINA_AJUDA, TextoAjuda } from "@/core/components/ajuda/ajudaUi";

/** Fim das lições. Nada é gravado aqui: cada lição já foi marcada como vista ao concluir. */
export function AjudaConcluida() {
  const navigate = useNavigate();
  const { modulosVisiveis } = useAuth();
  const { papel } = useAjudaPapel();
  const total = useMemo(() => montarLicoes(modulosVisiveis, papel).length, [modulosVisiveis, papel]);
  const tituloRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    tituloRef.current?.focus();
  }, []);

  return (
    <main className={`${PAGINA_AJUDA} text-center`}>
      <span className="mx-auto mb-5 grid h-16 w-16 place-items-center rounded-full bg-success/15 text-success">
        <Check size={32} aria-hidden="true" />
      </span>
      <h1
        ref={tituloRef}
        tabIndex={-1}
        className="mb-3 text-2xl font-black tracking-tight text-text outline-none sm:text-3xl"
      >
        Pronto!
      </h1>
      <TextoAjuda texto={`Você viu as ${total} lições.`} />
      <TextoAjuda
        texto="Para rever algo, abra o **menu** e toque em **Ajuda do Elos**."
        className="mt-3"
      />
      <div className="mt-8 flex flex-col gap-3 sm:items-center">
        <button type="button" onClick={() => navigate("/inicio")} className={BTN_PRIMARIO}>
          Ir para o Início
        </button>
        <button type="button" onClick={() => navigate("/ajuda")} className={BTN_TEXTO}>
          Ver a lista de lições
        </button>
      </div>
    </main>
  );
}
